import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    margin: 0;
    line-height: 22px;
  `,
}

export type DialogTitleProps = {
  className?: string
  children: React.ReactNode
  id: string
}

export function DialogTitle(props: DialogTitleProps) {
  const { children, id, className } = props
  return (
    <h2
      id={id}
      data-dialog-title
      className={cx("HeadlineH5BlackBold", styles.root, className)}
    >
      {children}
    </h2>
  )
}
